/**
 * Texto aceito pela NFS-e nacional nos campos de endereço (tipo `TSString` do
 * tiposSimples_v1.01.xsd): só caracteres de espaço a "ÿ" (U+0020–U+00FF).
 * Acento, ç e º passam; travessão, aspas curvas, emoji e tab não — o Emissor
 * Nacional recusa a NF inteira DEPOIS de emitida (E1235; caso Oba 2026-09-29,
 * travessão U+2014 no Complemento). Regra única: cadastro do cliente (tela +
 * API) e a checagem antes de emitir usam esta função.
 */
const OUTSIDE_NFSE_TEXT = /[^ -ÿ]/gu;

/** Caracteres (sem repetição, na ordem em que aparecem) que a NFS-e recusaria. */
export function nfseForbiddenChars(value: string | null | undefined): string[] {
  const found = value?.match(OUTSIDE_NFSE_TEXT);
  return found ? [...new Set(found)] : [];
}

/** Caractere pra mensagem: invisível (tab, espaço de largura zero) vira texto, não aspas vazias. */
export function describeNfseChar(ch: string): string {
  return /[\p{C}\p{Z}]/u.test(ch) ? 'um caractere invisível' : `"${ch}"`;
}
